export const ALLOCATION_MODES = {
    FIFO: 'FIFO',
    SERIALIZED: 'SERIALIZED',
};
